import { render, staticRenderFns } from "./RankingDetailsModal.vue?vue&type=template&id=167e2f89&scoped=true"
import script from "./RankingDetailsModal.vue?vue&type=script&lang=js"
export * from "./RankingDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./RankingDetailsModal.vue?vue&type=style&index=0&id=167e2f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e2f89",
  null
  
)

export default component.exports